import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-innovatie',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconInnovatie {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m26.32 22.22-6.62 6.64 1.77 3.45c.31.6 1.11.73 1.59.25l5.21-5.22a1 1 0 0 0 .17-1.18l-2.11-3.95Zm-14.44 4.93c-.59 0-1.02.48-1.06 1.06-.01.2 0 .19-.01.2.01.82-.29 1.58-.86 2.14-.68.68-3.59 1.5-6.58 2.07.56-3.01 1.39-5.92 2.06-6.6.55-.55 1.3-.86 2.09-.86h.04v-.02c.59 0 1.05-.48 1.05-1.06s-.47-1.06-1.06-1.06h-.03c-1.42 0-2.69.57-3.6 1.49-1.52 1.53-2.51 6.77-2.92 9.3-.11.7.49 1.3 1.18 1.19 2.52-.4 7.74-1.4 9.27-2.93.93-.93 1.48-2.27 1.48-3.7v-.15c0-.59-.47-1.06-1.06-1.06ZM3.55 14.36l3.32 1.73.12.05 6.63-6.66-3.97-2.09c-.39-.2-.86-.13-1.17.18l-5.18 5.2c-.48.48-.35 1.28.24 1.6ZM33.32 2.47A8.74 8.74 0 0 0 30.44 2c-3.43 0-7.69 1.16-11.11 4.59l-11.01 11 9.91 9.94 11-11.05c6.46-6.48 4.7-12.36 4.1-14Zm-6.6 10.68a2.848 2.848 0 0 1-4.04 0 2.873 2.873 0 0 1 0-4.06 2.848 2.848 0 0 1 4.04 0 2.873 2.873 0 0 1 0 4.06"/>
</svg>

    );
  }
}
